document.addEventListener('DOMContentLoaded', () => {
  setJourney()

  UWX.ScrollActionSelfElement('.feature_image-chara', {
    activeClass: '--actived',
    timing: 0,
    once: true,
    direction: 'both',
  });
})

const routeTree = {
  item: 'prod',
  select: {
    prod_kintone: {
      item: 'course',
      select: {
        course_yes: 'result_samedom',
        course_no: 'result_changekin',
      },
    },
    prod_mailwise: 'result_kinsta',
    prod_both: {
      item: 'course',
      select: {
        course_yes: {
          item: 'domain',
          select: {
            domain_yes: 'result_just',
            domain_no: 'result_cannot',
          }
        },
        course_no: 'result_changekin',
      },
    }
  }
}

const setJourney = () => {
  let journeySelect = routeTree
  let journeyRoute = []

  document.querySelector('.c-contract_journey-reset .g-btn').addEventListener('click', () => {
    journeySelect = routeTree
    journeyRoute = []
      Array.from(document.querySelectorAll('.c-contract_journey-item')).forEach((elm, i) => {
      if(i === 0){
        elm.classList.add('--actived')
        document.querySelector('.c-contract_journey-reset').classList.add('--actived')
      }else{
        elm.classList.remove('--actived')
        document.querySelector('.c-contract_journey-reset').classList.remove('--actived')
      }
    })
  })
  document.querySelectorAll('.c-contract_journey-menu .select_btn').forEach(elm => {
    elm.addEventListener('click', () => {
      if(journeySelect.select && journeySelect.select[elm.dataset.uwJourneySelect] !== void 0){
        document.querySelector(`.c-contract_journey-item[data-uw-journey-item="${journeySelect.item}"]`).classList.remove('--actived')
        const next = journeySelect.select[elm.dataset.uwJourneySelect]
        journeyRoute.push({
          item: journeySelect.item,
          select: elm.dataset.uwJourneySelect,
        })

        document.querySelector('.c-contract_journey-reset').classList.add('--actived')
        if(typeof next !== 'string'){
          document.querySelector(`.c-contract_journey-item[data-uw-journey-item="${next.item}"]`).classList.add('--actived')
          journeySelect = next
        }else{
          document.querySelector(`.c-contract_journey-item[data-uw-journey-item="${next}"]`).classList.add('--actived')
          journeySelect = {}
        }
      }else{
        const result = backJourney(elm, journeyRoute)
        journeySelect = result.select
        journeyRoute = result.route
      }
    })
  })
}

const backJourney = (elm, journeyRoute) => {
  let select = routeTree
  const route = []

  const opened = Array.from(document.querySelectorAll('.c-contract_journey-item')).filter(it => {
    return it.classList.contains('--actived')
  }).map(it => it.dataset.uwJourneyItem)
  let hiding = opened

  for(let i = 0; i < journeyRoute.length; i++){
    hiding = hiding.filter(t => t !== journeyRoute[i].item)

    const currentItem = elm.closest('.c-contract_journey-item').dataset.uwJourneyItem
    if(currentItem === journeyRoute[i].item){
      const next = select.select[elm.dataset.uwJourneySelect]
      route.push({
        item: currentItem,
        select: elm.dataset.uwJourneySelect
      })

      for(let j = 0; j < hiding.length; j++){
        document.querySelector(`.c-contract_journey-item[data-uw-journey-item="${hiding[j]}"]`).classList.remove('--actived')
      }
      if(typeof next !== 'string'){
        document.querySelector(`.c-contract_journey-item[data-uw-journey-item="${next.item}"]`).classList.add('--actived')
        select = next
      }else{
        document.querySelector(`.c-contract_journey-item[data-uw-journey-item="${next}"]`).classList.add('--actived')
        select = {}
      }

      return {select, route}
    }else{
      select = select.select[journeyRoute[i].select]
      route.push(journeyRoute[i])
    }
  }
  return {select, route}
}
